<template>
    <div>
        <section class="blockElement mainBanner autoChartist">
            <div class="container">
                <div class="inner-banner-custom row align-items-center">
                    <div class="col-12 col-md-6 left-block wow bounceInDown">
                        <h1 v-html="$t('ForexGlossarySpan')"></h1>
                        <p>{{$t('ForexGlossaryGuide')}}</p>
                        <!-- <div class="buttonBanner d-flex align-items-center mt-5">
                            <a href="#" class="cr-btn hvr-sweep-to-top greenBG">Calculate Now</a>
                        </div> -->
                    </div>
                    <div class="col-12 col-md-6 right-block  wow bounceInRight">
                        <div class="bannerSupport">
                            <!-- <img class="bull" src="../../../../static/fxview/images/forex-glossary.png" alt="Banner"> -->
                            <!--<div class="cta blob part forex-glossary" data-num="1">
                                <img src="../../../../static/fxview/images/footer-blob1.svg" alt="Icon">
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="blockElement forex-glossary-calculate homeContact position-relative between-footer doticonHover tp rightDots">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="border-bottom pb-2 top-calculation d-flex align-items-center justify-content-between mb-4">
                            <ul class="flex-wrap d-flex align-items-center justify-content-between w-100 mr-4 mb-0" >
                                <li v-for="(value,key) in dic_first_letter" @click="searchFun(key)" >{{key}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12 col-md-4" >
                        <div class="listBelow-blck" v-for="(value,key) in dic_list" v-if="key == 'A' || key == 'D' || key == 'G'  || key == 'N' || key == 'O' || key == 'S'  || key == 'W' || key == 'Y'" >
                            <span class="numaric" :id="key" :class="(id_select == key)?'active' : ''">{{key}}</span>
                            <ul class="toggleList">
                                <li v-for="(innerList,innerKey) in value">
                                    <span class="expander d-block position-relative" @click="showhideFunc(innerKey)">{{$t(innerKey)}}</span>
                                    <span v-if="showhide == innerKey" v-html="$t(innerList[0])"> </span>
                                </li>
                            </ul>
                        </div>
                    </div>
					
                    <div class="col-12 col-md-4" >
                        <div class="listBelow-blck" v-for="(value,key) in dic_list" v-if="key == 'B' || key == 'E' || key == 'H' || key == 'I' || key == 'L' || key == 'P' || key == 'Q' || key == 'T'" >
                            <span class="numaric" :id="key" :class="(id_select == key)?'active' : ''">{{key}}</span>
                            <ul class="toggleList">
                                <li v-for="(innerList,innerKey) in value">
                                    <span class="expander d-block position-relative" @click="showhideFunc(innerKey)">{{$t(innerKey)}}</span>
                                    <span v-if="showhide == innerKey" v-html="$t(innerList[0])"> </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-12 col-md-4" >
                        <div class="listBelow-blck" v-for="(value,key) in dic_list" v-if="key == 'C' || key == 'F' || key == 'M' || key == 'R' || key == 'U' || key == 'V'" >
                            <span class="numaric" :id="key" :class="(id_select == key)?'active' : ''">{{key}}</span>
                            <ul class="toggleList">
                                <li v-for="(innerList,innerKey) in value">
                                    <span class="expander d-block position-relative" @click="showhideFunc(innerKey)">{{$t(innerKey)}}</span>
                                    <span v-if="showhide == innerKey" v-html="$t(innerList[0])"> </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: 'forexglossary',
        data() {
            return {
				showhide : '',
				id_select : '',
				dic_first_letter : {
					'A' : {},'B' : {},'C' : {}, 'D' : { },'E' : {}, 'F' : { },'G' : {},'H' : { }, 'I' : { },'L' : { },'M' : {},'N' : { },
                    'O' : {},'P' : {},'Q' : {},'R' : { },'S' : {},'T' : { }, 'U' : {}, 'V' : { },'W' : { },'Y' : {}
				},
				dic_list :{},
                dictionary_list : {
                    'A' : {
                        'AGGREGATE_DEMAND' : ['text'],
                        'APPRECIATION' : ['AppText'],
                        'ARBITRAGE'  : ['ArbText'],
                        'AROUND'  : ['ArndText'],
                        'ASK_RATE'  : ['Asktext'],
                        'ASSET_ALLOCATION'  : ['AsstText'],
                    },
                    'B' : {
                        'Back_office' : ['btext1'],
                        'BalanceofTrade'  : ['btext2'],
                        'BarCharts'  : ['btext3'],
                        'BaseCurrency'  : ['btext4'],
                        'BearMarket'  : ['btext5'],
                        'BidRate'  : ['btext6'],
                    },
                    'C' : {
                        'CABLE' : ['CABLEText'],
                        'CANDLESTICK_CHART'  : ['CANDLESTICK_CHARTText'],
                        'CENTRAL_BANK'  : ['CENTRAL_BANKText'],
                        'CHARTISTs'  : ['CHARTISTsText'],
                        'CHOICE_MARKET'  : ['CHOICE_MARKETText'],
                        'CLEARING'  : ['CLEARINGtext'],
                        'CONTAGION'  : ['CONTAGIONText'],
                        'COLLATERAL' : ['COLLATERALText'],
                        'COMMISSION' : ['COMMISSIONText'],
                        'CONFIRMATION' : ['CONFIRMATIONText'],
                        'CONTRACTunit' : ['CONTRACTunitText'],
                        'COUNTERPARTY' : ['COUNTERPARTYText'],
                        'COUNTRY_RISK' : ['COUNTRY_RISKText'],
                        'CROSS_RATES' : ['CROSS_RATESText'],
                        'CURRENCYe' : ['CURRENCYText'],
                        'CURRENCY_RISK' : ['CURRENCY_RISKText'],
                    },
                    'D' : {
                        'Day_trading' : ['Day_tradingText'],
                        'Dealer' : ['DealerText'],
                        'Deficit' : ['DeficitText'],
                        'Delivery' : ['DeliveryText'],
                        'Depreciation' :  ['DepreciationText'],
                        'Derivative' : ['DerivativeText'],
                        'Devaluation' : ['DevaluationText'],
                    },
                    'E' : {
                        'ECONOMIC_INDICATOR' : ['ECONOMIC_INDICATORText'],
                        'ENDOFDAYORDER' : ['ENDOFDAYORDERText'],
                        'EUROs' : ['EUROsText'],
                        'EUROPEANCENTRALBANK' : ['EUROPEANCENTRALBANKText'],
                    },
                    'F' : {
                        'FederalDepositInsurance' : ['FederalDepositInsuranceText'],
                        'FederalReserveSystem' : ['FederalReserveSystemText'],
                        'FixedExchangeRate' : ['FixedExchangeRateText'],
                        'FloatingExchangeRate' : ['FloatingExchangeRateText'],
                        'Flatsquare' : ['FlatsquareText'],
                        'Foreign_Exchange' : ['Foreign_ExchangeText'],
                        'Forward' : ['ForwardText'],
                        'Forward_Contracts' : ['Forward_ContractsText'],
                        'ForwardRates' : ['ForwardRatesText'],
                        'Forward_Trading' : ['Forward_TradingText'],
                        'Forwardpoints' : ['ForwardpointsText'],
                        'Fundamental_Analysis' : ['Fundamental_AnalysisText'],
                        'FuturesContract' : ['FuturesContractText'],
                    },
                    'G' : {

                        'Gearing' : ['GearingText'],
                        'GroupofFive' : ['GroupofFiveText'],
                        'GroupofSeven' : ['GroupofSevenText'],
                        'GroupofTen' : ['GroupofTenText'],
                        'GoldilocksEconomy' : ['GoldilocksEconomyText'],
                        'GoodtilCancel' : ['GoodtilCancelText'],

                    },
                    'H' : {
                        'HEDGING' : ['HEDGINGText'],
                    },
                    'I' : {
                        'INFLATION' : ['INFLATIONText'],
                        'INITIALMARGIN' : ['INITIALMARGINText'],
                        'INTERBANKRATES' : ['INTERBANKRATESText'],
                    },
                    'L' : {
                        'LEADINGINDICATORS' : ['LEADINGINDICATORSText'],
                        'LEVERAGEs' : ['LEVERAGEsText'],
                        'LIBOR' : ['LIBORText'],
                        'LIMITORDER' : ['LIMITORDERText'],
                        'LINECHARTS' : ['LINECHARTSText'],
                        'LIQUIDITYs' :  ['LIQUIDITYsText'],
                        'LIQUIDATION' : ['LIQUIDATIONText'],
                        'LONGPOSITION': ['LONGPOSITIONText'],
                    },
                    'M' : {
                        'Margin' : ['MarginText'],
                        'MarginDeposit' : ['MarginDepositText'],
                        'MarginCall' : ['MarginCallText'],
                        'MarketMaker' : ['MarketMakerText'],
                        'MarketRisk' : ['MarketRiskText'],
                        'Marktomarket' :  ['MarktomarketText'],
                        'Maturity' : ['MaturityText'],
                    },
                    'N' : {
                        'NarrowMarket' : ['NarrowMarketText']
                    },
                    'O' : {
                        'Offer_s' : ['OfferText'],
                        'Offsettingtransaction' : ['OffsettingtransactionText'],
                        'OneCancelsOrder' : ['OneCancelsOrderText'],
                        'Openorder' : ['OpenorderText'],
                        'Open_position' : ['OpenPositionText'],
                        'OvertheCounter' : ["OvertheCounterText"],
                        'Overnight' : ['OvernightText'],
                    },
                    'P' : {
                        'Pip_s' : ['PipText'],
                        'PoliticalRisk' : ['PoliticalRiskText'],
                        'PointFigureCharts' : ['PointFigureChartsText'],
                        'Position_s' : ['PositionText'],
                        'Premium' : ['PremiumText'],
                        'PriceTransparency' : ['PriceTransparencyText'],
                    },
                    'Q' : {
                        'Quote_s' : ['QuoteText'],
                    },
                    'R' : {
                        'RATE_s' : ['RATEText'],
                        'RESISTANCE_s' : ['RESISTANCEText'],
                        'REVALUATION' : ['REVALUATIONText'],
                        'REVALUATIONRATES' : ['REVALUATIONRATESText'],
                        'RISK_s' : ['RISKText'],
                        'RISKCAPITAL' : ['RISKCAPITALText'],
                        'RISK_MANAGEMENT' : ['RISKMANAGEMENTText'],
                        'ROLLOVER' :  ['ROLLOVERText'],
                        'ROLLOVERRATE' : ['ROLLOVERRATEText'],
                    },
                    'S' : {
                        'SETTLEMENT' : ['SETTLEMENTText'],
                        'SHORTPOSITION' : ['SHORTPOSITIONText'],
                        'SLIPPAGE' : ['SLIPPAGEText'],
                        'SPOTNEXT' : ['SPOTNEXTText'],
                        'SPOTPRICE' : ['SPOTPRICEText'],
                        'SPOTRATE' : ['SPOTRATEText'],
                        'SPOTTRADE' : ['SPOTTRADEText'],
                        'Spread_s' : ['SpreadText'],
                        'Sterling' : ['SterlingText'],
                        'StopLossOrder' : ['StopLossOrderText'],
                        'StochasticOscillator': ['StochasticOscillatorText'],
                        'SupportLevels' : ['SupportLevelsTexts'],
                        'Swap_s' : ['SwapText'],
                        'Swift' : ['SwiftText'],
                    },
                    'T' : {
                        'TECHNICALANALYSIS' : ['TECHNICALANALYSISText'],
                        'TICK_s' : ['TICKText'],
                        'TICKER' : ['TICKERText'],
                        // 'TOMORROWNEXT' : [''],
                        'TRADING_s' : ['TRADINGText'],
                        'TRANSACTIONCOST' : ['TRANSACTIONCOSTText'],
                        'TRANSACTIONDATE' : ['TRANSACTIONDATEText'],
                        'TREND_s' : ['TRENDText'],
                        'TRENDLINE' : ['TRENDLINEText'],
                        // 'TURNOVER' : [''],
                        'TWO WAY PRICE' : ['TWOWAYPRICEText'],
                    },
                    'U' : {
                        'UPTICK' : ['UPTICKText'],
                        'UPTICKRULE' : ['UPTICKRULEText'],
                        'USPRIMERATE' : ['USPRIMERATEText'],
                    },
                    'V' : {
                        'VALUEDATE' : ['VALUEDATEText'],
                        'VARIATIONMARGIN' : ['VARIATIONMARGINText'],
                        'VOLATILITYVOL' : ['VOLATILITYVOLText'],
                        'VOLUME_s' : ['VOLUMEText'],
                    },
                    'W' : {
                        'WeakDollarStrongDollar' : ['WeakDollarStrongDollarText'],
                        'Whipsaw' : ['WhipsawText'],
                    },
                    'Y' : {
                        'Yard' : ['YardText'],
                        'YIELD' : ['YIELDText'],
                    },
                },
            }
        },
        methods:{
			searchFun(getData){
				var elmnt = document.getElementById(getData);
				elmnt.scrollIntoView();
				this.id_select = getData
				document.getElementById(getData).focus();
                /*var top = $(".mainContent").scrollTop()
                $('.mainContent').scrollTop(top-150)*/
			},
            showhideFunc(getData){
                if(this.showhide == getData){
                    this.showhide = ''
                }else{
                    this.showhide = getData
                }
            }
        },
        mounted() {
            var div_top = $('.top-calculation').offset().top;
            $(".mainContent").scroll(function() {
                var window_top = $(".mainContent").scrollTop() - 0;
                if (window_top > div_top) {
                    if (!$('.top-calculation').is('.sticky')) {
                        $('.top-calculation').addClass('sticky');
                    }
                } else {
                    $('.top-calculation').removeClass('sticky');
                }
            });
            
        },
		created(){
			this.dic_list = this.dictionary_list
		}
    }
</script>




// WEBPACK FOOTER //
// src/components/fxView/research/pages/forex_glossary.vue